exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".notes_container[data-v-f4a67002]{display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around}", "", {"version":3,"sources":["/home/runner/work/KeepNeyeVue/KeepNeyeVue/src/components/module/special-components/Other-components/CreateNote.vue"],"names":[],"mappings":"AACA,kCACE,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,4BAA8B,CACnC","file":"CreateNote.vue","sourcesContent":["\n.notes_container[data-v-f4a67002] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n"],"sourceRoot":""}]);

// exports
